export const OfferContentFragment = {
    name: 'offerContent',
    value: `
fragment offerContent on Offer {
    provideServicesInClinic
    draftStaffingPlan {
        comments
        fullOfferStartDate
        reviewedAndApprovedByClientFamilyDate
        offeredParaprofessionalHours
        offeredMidLevelHours
        offeredHighLevelHours
        offeredGroupCareHours
    }
    clinic {
      id
      guid
      location
      street
      city
      stateCode
      zipCode
    }
    otherClinicLocation
    provideServiceInRequiredLanguage
    firstServiceDate
    provideAllEstimatedHours
    directCareHours
    midLevelSupervisionHours
    highLevelSupervisionHours
    groupCareHours
    lastServiceDate
    comments
    treatmentOffered
    caregiverMediatedMidLevelHours
    caregiverMediatedHighLevelHours
    startDateCaregiverMediatedTreatment
    startDatePractMediatedTreatment
    serviceLocationType
    serviceLocationParaprofessionalType
    serviceLocationMidLevelType
    serviceLocationHighLevelType
    serviceLocationGroupCareType
    psychotherapyOffer
}
`
}

export const StatusAndSubmitter = {
    name: 'statusAndSubmitter',
    value: `
fragment statusAndSubmitter on Offer {
    status
    submittedAt
    submittedBy {
      id
      guid
      firstName
      lastName
    }
}    
`,
}
